import { useApiEffectWithParams } from 'framework/hooks/useApiEffectWithParams';
import { IProductCatalogQueryParamsForDelivery, productCatalogQuery_queryForDelivery } from 'gen/ApiClient';
import React from 'react';
import { SearchContext } from './SearchContext';

const DefaultParams: IProductCatalogQueryParamsForDelivery = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	categories: [],
	subcategories: [],
	types: [],
};

interface IProps {
	children: any;
}

export const SearchProvider = ({ children }: IProps) => {
	const [params, setParams, queryResult] = useApiEffectWithParams(productCatalogQuery_queryForDelivery, DefaultParams);

	return (
		<SearchContext.Provider
			value={{
				params: params,
				queryResult: queryResult,
				setParams: setParams,
			}}>
			{children}
		</SearchContext.Provider>
	);
};
